module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e6a07a5b0c214c0545a02d4b42269378.png";